import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { notification } from 'ant-design-vue'
import { HttpCode } from '../interface/index'
const REQUEST_INFO: HttpCode = {
  400: {
    message: '您的请求异常，请联系客服处理！'
  },
  401: {
    message: '您的登录信息异常，请联系客服处理！'
  },
  403: {
    message: '您无权访问该资源，请联系客服处理！'
  },
  404: {
    message: '您请求的资源不存在！'
  },
  406: {
    message: '您的请求异常，请联系客服处理！'
  },
  422: {
    message: '您的请求异常，请联系客服处理！'
  },
  others: {
    message: '服务器报错了！'
  }
}
const httpRequest = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 60000,
  headers: { // 解决ie自动缓存
    'cache-control': 'no-cache',
    Pragma: 'no-cache',
    appCode:'purchase'
  }
})




const handleResponseError = (error: any) => {
  if (error.response) {
    const status = error.response.status
    const token = Vue.ls.get( 'ACCESS_TOKEN' )
    const customerInfo = Vue.ls.get( 'customerInfo' )
    if (status === 401) { // 无token或token过期处理
      notification.error({
        message: '请求错误',
        description: '您的登录信息异常,请联系客服处理!'
      })
      if (token) { // token过期处理
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
      }
    } else if (String(status).indexOf('4') > -1) {
      notification.error({
        message: '请求错误',
        description: REQUEST_INFO[status].message
      })
    } else {
      notification.error({
        message: '请求错误',
        description: REQUEST_INFO.others.message
      })
    }
  }
  return Promise.reject(error)
}


export function deleteAction(url: any, parameter: { id: any }) {
  return httpRequest({
      url: `${url}/${parameter.id}`,
      method: 'delete'
  })
}
const handleRequestError = (error: any) => {
  return Promise.reject(error)
}

// 请求拦截
httpRequest.interceptors.request.use((config: any) => {
  const isConnectNet = window.navigator.onLine
  if (!isConnectNet) { // 断网提示
    notification.error({
      description: 'connect_lost',
      message: '网络已断开，请检查网络连接！'
    })
    return config
  }
  const customerInfo = Vue.ls.get( 'customerInfo' )
  // config.headers.Authorization = '1703fb23bae57681bbfdf8fdabf0e8e7'
  if ( customerInfo ) {
    config.headers.clientInstanceId = customerInfo.clientId
    config.headers.appCode = customerInfo.appCode
    config.headers.userId = customerInfo.userId
  }
  const userInfo =JSON.parse(localStorage.getItem('client') as any)
  if ( userInfo ) {
    config.headers.HeaderCustId = userInfo.supervisionCustId
  }
  const token = Vue.ls.get('ACCESS_TOKEN')

  // Vue.ls.get('ACCESS_TOKEN')||
  if (token) {
      config.headers.Authorization = token
  }
  return config
}, handleRequestError)

// 响应拦截
httpRequest.interceptors.response.use(response => {

  if(response.headers['content-disposition']){
    Vue.ls.set('filetype',response.headers['content-disposition'].split('=')[1])
  }

  const status = response.status
  if (status === 200) {
    if (response.data.status === 52118 || response.data.status === 52119 || response.data.status === 52120) { // token失效过期
      notification.error({
        description: '',
        message: '当前登录身份已过期, 请重新登录!'
      })
      const customerInfo = Vue.ls.get('customerInfo')
      if (customerInfo) {
        Vue.ls.remove('customerInfo') 
      
      }
      setTimeout(function () {
        Vue.ls.remove('ACCESS_TOKEN')// 删除token
        window.location.reload()
      }, 1200)
      return Promise.reject(new Error(response.data.message || 'Error'))
    } else if (response.data.status === 50000) {
      notification.error({
        description: 'serviceError',
        message: response.data.message || '服务报错了!'
      })
      return Promise.reject(response.data.message || '服务报错了!')
    } else {
      return response.data
    }
  }
}, handleResponseError)

export default httpRequest
